import { css } from 'lit-element';


export const ResponsiveStyles = css`

  

`;

